/**
 * 连接按钮组件
 * 根据当前连接状态显示连接/断开按钮
 */
import { useConnectionStore } from '@/stores/connection';
import { useWebSocket } from '@/hooks/use-websocket';
import { Loader2, Plug, Unplug } from 'lucide-react';
import { Button } from '../common/button';

/** 连接按钮：根据串口连接状态显示连接/断开操作 */
export function ConnectButton() {
  const state = useConnectionStore((s) => s.state);
  const port = useConnectionStore((s) => s.port);
  const baudRate = useConnectionStore((s) => s.baudRate);
  const error = useConnectionStore((s) => s.error);
  const setError = useConnectionStore((s) => s.setError);
  const { send } = useWebSocket();

  const handleClick = () => {
    setError(null);
    if (state === 'connected' || state === 'connecting') {
      send({ type: 'disconnect' });
    } else {
      if (!port) return;
      send({ type: 'connect', payload: { port, baudRate } });
    }
  };

  const isConnected = state === 'connected';
  const isConnecting = state === 'connecting' || state === 'reconnecting';

  return (
    <div className="flex items-center gap-2">
      <Button
        variant={isConnected ? 'danger' : 'primary'}
        size="sm"
        onClick={handleClick}
        disabled={!port && !isConnected && !isConnecting}
        icon={isConnecting ? <Loader2 className="h-4 w-4 animate-spin" /> : isConnected ? <Unplug className="h-4 w-4" /> : <Plug className="h-4 w-4" />}
      >
        {isConnecting ? '连接中…' : isConnected ? '断开' : '连接'}
      </Button>
      {error && (
        <span className="text-xs text-red-400 max-w-[200px] truncate">{error}</span>
      )}
    </div>
  );
}
